import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, FormInput, FormInputNumber, FormSelect, PrimaryButton, Units, setDateWithTimezone, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { InternalError } from '@systemeio/util';
import { CouponErrorsInterface } from 'modules/coupons/types/coupon-interface';
import { getDiscountTypeData } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/utils/coupons-utils';
import React, { useState } from 'react';
import ButtonLikeLink from 'shared/components/button-like-link';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { filterPassedTime } from 'shared/utils/date-time-format';
import { CouponCreateInterface } from '../types/add-coupon-data-interface';
import { CloseIcon, SaveIcon } from '@systemeio/ui/icons';
interface CreateCouponFormProps {
  onCreateCoupon: (value: CouponCreateInterface) => Promise<void>;
  openAddForm: () => void;
  closeForm: () => void;
  createFieldErrors: CouponErrorsInterface;
}
const defaultValues: CouponCreateInterface = {
  innerName: '',
  code: '',
  discountType: undefined,
  discountAmount: 0 as Units,
  currency: undefined as unknown as CouponCreateInterface['currency'],
  expirationDate: null,
  limitOfUse: NaN
};
function CreateCouponForm(t0) {
  const $ = _c(114);
  const {
    onCreateCoupon,
    openAddForm,
    closeForm,
    createFieldErrors
  } = t0;
  const {
    user,
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState(defaultValues);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== closeForm || $[1] !== onCreateCoupon || $[2] !== t || $[3] !== tempState) {
    t1 = async () => {
      ;
      try {
        setError("");
        setIsFetching(true);
        await onCreateCoupon(tempState);
        setIsFetching(false);
        closeForm();
      } catch (t2) {
        const e = t2;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.common) {
            setError(e.errors.common.join(""));
          }
        } else {
          if (e instanceof InternalError) {
            setError(t("core.error.internal_error_message"));
          } else {
            toast.error(t("global.error"));
          }
        }
      }
    };
    $[0] = closeForm;
    $[1] = onCreateCoupon;
    $[2] = t;
    $[3] = tempState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleConfirm = t1;
  const t2 = `cursor-pointer ${isFetching && "fill-text-secondary pointer-events-none"} absolute right-1 top-1 lg:right-2 lg:top-2`;
  let t3;
  if ($[5] !== closeForm) {
    t3 = () => closeForm();
    $[5] = closeForm;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <CloseIcon className={t2} onClick={t3} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("dashboard.coupon.coupon_name");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("global.name");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setTempState(prev => ({
      ...prev,
      innerName: e_0.target.value
    }));
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== createFieldErrors.innerName || $[16] !== t5 || $[17] !== t6 || $[18] !== tempState.innerName) {
    t8 = <FormInput required={true} label={t5} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" placeholder={t6} value={tempState.innerName} onChange={t7} maxLength={256} error={createFieldErrors.innerName} />;
    $[15] = createFieldErrors.innerName;
    $[16] = t5;
    $[17] = t6;
    $[18] = tempState.innerName;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.coupon.coupon_code");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("dashboard.coupon.coupon_code");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e_1 => setTempState(prev_0 => ({
      ...prev_0,
      code: e_1.target.value
    }));
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== createFieldErrors.code || $[26] !== t10 || $[27] !== t9 || $[28] !== tempState.code) {
    t12 = <FormInput required={true} label={t9} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" placeholder={t10} value={tempState.code} onChange={t11} maxLength={256} error={createFieldErrors.code} />;
    $[25] = createFieldErrors.code;
    $[26] = t10;
    $[27] = t9;
    $[28] = tempState.code;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t("dashboard.funnel.configuration.offer.coupon_discount_type");
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = getDiscountTypeData(t);
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = data => setTempState(prev_1 => ({
      ...prev_1,
      discountType: data
    }));
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== createFieldErrors.discountType || $[36] !== t13 || $[37] !== t14 || $[38] !== tempState.discountType) {
    t16 = <FormSelect label={t13} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" data={t14} onChange={t15} value={tempState.discountType} required={true} error={createFieldErrors.discountType} />;
    $[35] = createFieldErrors.discountType;
    $[36] = t13;
    $[37] = t14;
    $[38] = tempState.discountType;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t12 || $[41] !== t16) {
    t17 = <div className="flex gap-5">{t12}{t16}</div>;
    $[40] = t12;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t) {
    t18 = t("dashboard.coupon.discount_amount");
    $[43] = t;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = value => setTempState(prev_2 => ({
      ...prev_2,
      discountAmount: value as Units
    }));
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  const t20 = tempState.discountAmount ?? 0;
  let t21;
  if ($[46] !== createFieldErrors.discountAmount || $[47] !== t18 || $[48] !== t20) {
    t21 = <FormInputNumber required={true} label={t18} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" onChange={t19} value={t20} min={0} toFixed={2} error={createFieldErrors.discountAmount} />;
    $[46] = createFieldErrors.discountAmount;
    $[47] = t18;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  const t22 = tempState.expirationDate;
  let t23;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = data_0 => setTempState(prev_3 => ({
      ...prev_3,
      expirationDate: data_0
    }));
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t) {
    t24 = t("dashboard.coupon.expiration_date");
    $[51] = t;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const t25 = user?.timezone;
  let t26;
  if ($[53] !== t25) {
    t26 = setDateWithTimezone("", t25);
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== user?.timezone) {
    t27 = time => filterPassedTime(time, user?.timezone);
    $[55] = user?.timezone;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t26 || $[58] !== t27) {
    t28 = {
      minDate: t26,
      filterTime: t27
    };
    $[57] = t26;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  const t29 = user?.createdAt;
  const t30 = user?.timezone;
  const t31 = user?.dateFormat;
  const t32 = user?.timeFormat;
  let t33;
  if ($[60] !== createFieldErrors.expirationDate || $[61] !== intlLocale || $[62] !== t24 || $[63] !== t28 || $[64] !== t29 || $[65] !== t30 || $[66] !== t31 || $[67] !== t32 || $[68] !== tempState.expirationDate) {
    t33 = <DateTimePicker value={t22} onChange={t23} label={t24} customProps={t28} key="coupon-expirationDate-create" labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" error={createFieldErrors.expirationDate} createdAt={t29} timezone={t30} userDateFormat={t31} userTimeFormat={t32} intlLocale={intlLocale} />;
    $[60] = createFieldErrors.expirationDate;
    $[61] = intlLocale;
    $[62] = t24;
    $[63] = t28;
    $[64] = t29;
    $[65] = t30;
    $[66] = t31;
    $[67] = t32;
    $[68] = tempState.expirationDate;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== t) {
    t34 = t("dashboard.coupon.limit_of_use");
    $[70] = t;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = e_2 => setTempState(prev_4 => ({
      ...prev_4,
      limitOfUse: e_2.target.valueAsNumber
    }));
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  const t36 = !tempState.limitOfUse && tempState.limitOfUse !== 0 ? "" : tempState.limitOfUse;
  let t37;
  if ($[73] !== createFieldErrors.limitOfUse || $[74] !== t34 || $[75] !== t36) {
    t37 = <FormInput label={t34} type="number" onChange={t35} value={t36} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" min={0} maxLength={256} error={createFieldErrors.limitOfUse} />;
    $[73] = createFieldErrors.limitOfUse;
    $[74] = t34;
    $[75] = t36;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  let t38;
  if ($[77] !== t33 || $[78] !== t37) {
    t38 = <div className="flex gap-5">{t33}{t37}</div>;
    $[77] = t33;
    $[78] = t37;
    $[79] = t38;
  } else {
    t38 = $[79];
  }
  let t39;
  if ($[80] !== t) {
    t39 = t("dashboard.funnel.configuration.offer.create_coupon_footer");
    $[80] = t;
    $[81] = t39;
  } else {
    t39 = $[81];
  }
  let t40;
  if ($[82] !== t39) {
    t40 = <span>{t39}</span>;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  let t41;
  if ($[84] !== openAddForm) {
    t41 = () => {
      openAddForm();
    };
    $[84] = openAddForm;
    $[85] = t41;
  } else {
    t41 = $[85];
  }
  let t42;
  if ($[86] !== t) {
    t42 = t("dashboard.funnel.configuration.offer.create_coupon_footer_link");
    $[86] = t;
    $[87] = t42;
  } else {
    t42 = $[87];
  }
  let t43;
  if ($[88] !== t41 || $[89] !== t42) {
    t43 = <ButtonLikeLink onClick={t41}>{t42}</ButtonLikeLink>;
    $[88] = t41;
    $[89] = t42;
    $[90] = t43;
  } else {
    t43 = $[90];
  }
  let t44;
  if ($[91] !== t40 || $[92] !== t43) {
    t44 = <div className="text-text-primary flex w-full flex-col gap-2 text-sm font-medium lg:flex-row lg:text-[15px]">{t40}{t43}</div>;
    $[91] = t40;
    $[92] = t43;
    $[93] = t44;
  } else {
    t44 = $[93];
  }
  let t45;
  if ($[94] !== handleConfirm) {
    t45 = e_3 => {
      e_3.preventDefault();
      handleConfirm();
    };
    $[94] = handleConfirm;
    $[95] = t45;
  } else {
    t45 = $[95];
  }
  let t46;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <SaveIcon />;
    $[96] = t46;
  } else {
    t46 = $[96];
  }
  let t47;
  if ($[97] !== t) {
    t47 = t("global.save");
    $[97] = t;
    $[98] = t47;
  } else {
    t47 = $[98];
  }
  let t48;
  if ($[99] !== isFetching || $[100] !== t45 || $[101] !== t47) {
    t48 = <div className="flex"><PrimaryButton width="large" onClick={t45} isFetching={isFetching} type="submit">{t46}{t47}</PrimaryButton></div>;
    $[99] = isFetching;
    $[100] = t45;
    $[101] = t47;
    $[102] = t48;
  } else {
    t48 = $[102];
  }
  let t49;
  if ($[103] !== error) {
    t49 = <FieldErrorAndDescription error={error} errorClassName="text-center mt-2" />;
    $[103] = error;
    $[104] = t49;
  } else {
    t49 = $[104];
  }
  let t50;
  if ($[105] !== t17 || $[106] !== t21 || $[107] !== t38 || $[108] !== t4 || $[109] !== t44 || $[110] !== t48 || $[111] !== t49 || $[112] !== t8) {
    t50 = <div className="border-text-secondary/30 relative flex flex-col gap-5 rounded-lg border px-5 py-3">{t4}{t8}{t17}{t21}{t38}{t44}{t48}{t49}</div>;
    $[105] = t17;
    $[106] = t21;
    $[107] = t38;
    $[108] = t4;
    $[109] = t44;
    $[110] = t48;
    $[111] = t49;
    $[112] = t8;
    $[113] = t50;
  } else {
    t50 = $[113];
  }
  return t50;
}
export default CreateCouponForm;